module.exports = __webpack_public_path__ + "static/media/paymentFailed.7436417c.webp";